var map = {
	"./11.png": 458,
	"./12.png": 459,
	"./15.png": 460,
	"./1piechart.png": 461,
	"./2piechart.png": 462,
	"./3piechart.png": 463,
	"./4piechart.png": 464,
	"./Asset 1.png": 465,
	"./Asset 10.png": 466,
	"./Asset 12.png": 467,
	"./Asset 13 2.png": 468,
	"./Asset 13.png": 469,
	"./Asset 14.png": 470,
	"./Asset 15.png": 471,
	"./Asset 16.png": 472,
	"./Asset 17.png": 473,
	"./Asset 18.png": 474,
	"./Asset 19.png": 475,
	"./Asset 1_6.png": 476,
	"./Asset 2.png": 477,
	"./Asset 20.png": 478,
	"./Asset 21.png": 479,
	"./Asset 22.png": 480,
	"./Asset 23.png": 481,
	"./Asset 2_6.png": 482,
	"./Asset 3.png": 483,
	"./Asset 3_6.png": 484,
	"./Asset 4.png": 485,
	"./Asset 4_6.png": 486,
	"./Asset 5.png": 487,
	"./Asset 5_6.png": 488,
	"./Asset 7.png": 489,
	"./Asset 762.png": 490,
	"./Asset 8.png": 491,
	"./Asset 9.png": 492,
	"./output-onlinepngtools.png": 493,
	"./p1.png": 494,
	"./p2.png": 495,
	"./p3.png": 496,
	"./p4.png": 497,
	"./p5.png": 498,
	"./p6.png": 499,
	"./p7.png": 500,
	"./p8.png": 501,
	"./software.png": 502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;